@let loc = location();
<div
  [routerLink]="['/main/locations', loc.id]"
  class="bg-white rounded-2xl shadow p-4 mb-3 flex items-center gap-4 cursor-pointer hover:bg-gray-50 transition-colors"
  [class.opacity-60]="!isActive(loc)"
>
  <app-avatar fallback="photo" [src]="loc.avatarThumbnailUrl" [name]="loc.name" />

  <div class="flex flex-col gap-1 min-w-0 flex-1">
    <div class="flex items-baseline justify-between gap-2">
      <div class="flex items-center gap-2 min-w-0">
        <h3 class="text-xl font-semibold truncate">{{ loc.name }}</h3>
        @if (!isActive(loc)) {
          <span class="shrink-0 rounded-full bg-gray-200 px-2 py-0.5 text-xs font-medium text-gray-700">Disabled</span>
        }
      </div>
      <span class="text-sm text-gray-500 shrink-0">#{{ loc.order }}</span>
    </div>
    <div class="text-gray-700 truncate">{{ formatAddress(loc) }}</div>
    @if (loc.description) {
      <div class="text-sm text-gray-500 mt-1 truncate">{{ loc.description }}</div>
    }
  </div>
</div>
